import React, { useEffect, useState } from "react";
import PublicLayout from "../components/PublicLayout";
import api from "../lib/api";

export default function PreviousResult() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/previous", { params: { published_only: true } })
      .then((r) => setRows(r.data || []))
      .finally(() => setLoading(false));
  }, []);

  return (
    <PublicLayout title="Lucky Teer">
      <div className="nt-container mt-6">
        <div className="overflow-x-auto">
          <table className="nt-table" data-testid="previous-table">
            <thead>
              <tr>
                <th colSpan={4} className="text-lg">Lucky Teer Results</th>
              </tr>
              <tr>
                <th>CITY</th>
                <th>DATE</th>
                <th>F/R</th>
                <th>S/R</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={4} className="text-center py-6">Loading…</td>
                </tr>
              ) : rows.length === 0 ? (
                <tr>
                  <td colSpan={4} className="text-center py-6 text-slate-500">
                    No previous results yet.
                  </td>
                </tr>
              ) : (
                rows.map((r) => (
                  <tr key={r.id}>
                    <td>{r.city}</td>
                    <td>{r.date}</td>
                    <td>{r.fr || "-"}</td>
                    <td>{r.sr || "-"}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        <p className="text-center text-xs text-slate-500 mt-3">
          Newest results appear at the top.
        </p>
      </div>
    </PublicLayout>
  );
}
